export default __webpack_public_path__ + "static/media/voteLogo.77c2b0b2.svg";